import FacebookBindAccount from './FacebookBindAccount'

export default FacebookBindAccount
